module.exports = "/_next/static/media/2ca0b43f05bf0e81312e60df120e9643.svg";